<template>
  <div class="flex items-center justify-center playlist-container w-100 relative mw-100 overflow-hidden textColor">
    <div class="flex items-center justify-start">
      <div class="picture flex item-center justify-center">
        <img class="w-100 h-100" :src="picture">
      </div>
      <div class="mw-100 playlist-data">
        <h1 class="playlist-info f6 f5-ns fw6 lh-title mv0 mw-100 textColor">{{playlist.title}}</h1>
        <h2 class="playlist-info f6 fw4 mt0 mb0 black-60 mw-100 textColor">{{playlist.name}}</h2>
      </div>
    </div>
  </div>
</template>

<script>
  import consts from '@/consts'

  export default {
    name: 'playlist-info',
    props: {
      playlist: {
        required: true
      }
    },
    computed: {
      picture () {
        return consts.MEDIA_BASE_URL + this.playlist.picture
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';
  .playlist-container {
    flex-grow: 1;
  }

  .picture {
    height: 45px;
    width: 45px;
    min-height: 45px;
    min-width: 45px;
    max-height: 45px;
    max-width: 45px;
    margin-left: 5px;
  }

  .playlist-info {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .playlist-data {
    margin-left: 10px;
    max-width: 20vw;
  }

  @media screen and (min-width: 1440px) {
    .playlist-data {
      max-width: 10vw;
    }
  }

  @media screen and (max-width: 479px) {
    .playlist-data {
      font-size: .75rem;
      max-width: 75vw;
    }
  }

  @media screen and (min-width: 480px) and (max-width: 779px) {
    .playlist-data {
      max-width: 35vw;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/playlists/PlaylistInfo.vue